import { ChatEngineHandle } from '../chat-model.interface';
import { NotificationEngineService } from '../../../event-notifications/services/notification-engine.service';

export abstract class ChatEngineNotificationChannelService extends NotificationEngineService {
  public abstract openNotificationChannel(engineHandle: ChatEngineHandle, notificationChannelUniqueName: string): void;

  public abstract closeNotificationChannel(): void;
}
